export default __webpack_public_path__ + "static/media/cerner2.153dc0af.png";